import * as React from "react";
import { useSunglassesPriceFrom } from "../../../../../../../hooks/modules/EcommContent/SunglassesEcommContent/hooks/use-sunglasses-price-from.js";
import { PriceSectionContainer } from "../../../../../../../../components/PriceSection/modules/EcommContent/components/PriceSection/PriceSectionContainer.js";
const SunglassesPriceSection = () => {
  const { fromPricePrefix, shouldDisplayFromPrice } = useSunglassesPriceFrom();
  return /* @__PURE__ */ React.createElement(
    PriceSectionContainer,
    {
      shouldDisplayFromPrice,
      fromPricePrefix
    }
  );
};
export {
  SunglassesPriceSection
};
//# sourceMappingURL=SunglassesPriceSection.js.map
